function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _require = require('./mouse.js'),
    Mouse = _require.Mouse,
    Point = _require.Point;

var Constants = require('./constants.js');

var _require2 = require('./events.js'),
    AtramentEventTarget = _require2.AtramentEventTarget;

var Pixels = require('./pixels.js');

var DrawingMode = {
  DRAW: 'draw',
  ERASE: 'erase',
  FILL: 'fill'
};
var PathDrawingModes = [DrawingMode.DRAW, DrawingMode.ERASE];

module.exports = /*#__PURE__*/function (_AtramentEventTarget) {
  _inherits(Atrament, _AtramentEventTarget);

  var _super = _createSuper(Atrament);

  function Atrament(selector) {
    var _this;

    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Atrament);

    if (typeof window === 'undefined') {
      throw new Error('Looks like we\'re not running in a browser');
    }

    _this = _super.call(this); // get canvas element

    if (selector instanceof window.Node && selector.tagName === 'CANVAS') _this.canvas = selector;else if (typeof selector === 'string') _this.canvas = document.querySelector(selector);else throw new Error("can't look for canvas based on '".concat(selector, "'"));
    if (!_this.canvas) throw new Error('canvas not found'); // set external canvas params

    _this.canvas.width = config.width || _this.canvas.width;
    _this.canvas.height = config.height || _this.canvas.height; // create a mouse object

    _this.mouse = new Mouse(); // mousemove handler

    var mouseMove = function mouseMove(event) {
      if (event.cancelable) {
        event.preventDefault();
      }

      var rect = _this.canvas.getBoundingClientRect();

      var position = event.changedTouches && event.changedTouches[0] || event;
      var x = position.offsetX;
      var y = position.offsetY;

      if (typeof x === 'undefined') {
        x = position.clientX - rect.left;
      }

      if (typeof y === 'undefined') {
        y = position.clientY - rect.top;
      }

      var _assertThisInitialize = _assertThisInitialized(_this),
          mouse = _assertThisInitialize.mouse; // draw if we should draw


      if (mouse.down && PathDrawingModes.includes(_this.mode)) {
        var _this$draw = _this.draw(x, y, mouse.previous.x, mouse.previous.y),
            newX = _this$draw.x,
            newY = _this$draw.y;

        if (!_this._dirty && _this.mode === DrawingMode.DRAW && (x !== mouse.x || y !== mouse.y)) {
          _this._dirty = true;

          _this.fireDirty();
        }

        mouse.set(x, y);
        mouse.previous.set(newX, newY);
      } else {
        mouse.set(x, y);
      }
    }; // mousedown handler


    var mouseDown = function mouseDown(event) {
      if (event.cancelable) {
        event.preventDefault();
      } // update position just in case


      mouseMove(event); // if we are filling - fill and return

      if (_this.mode === DrawingMode.FILL) {
        _this.fill();

        return;
      } // remember it


      var _assertThisInitialize2 = _assertThisInitialized(_this),
          mouse = _assertThisInitialize2.mouse;

      mouse.previous.set(mouse.x, mouse.y);
      mouse.down = true;

      _this.beginStroke(mouse.previous.x, mouse.previous.y);
    };

    var mouseUp = function mouseUp(e) {
      if (_this.mode === DrawingMode.FILL) {
        return;
      }

      var _assertThisInitialize3 = _assertThisInitialized(_this),
          mouse = _assertThisInitialize3.mouse;

      var position = e.changedTouches && e.changedTouches[0] || e;
      var x = position.offsetX;
      var y = position.offsetY;
      mouse.down = false;

      if (mouse.x === x && mouse.y === y && PathDrawingModes.includes(_this.mode)) {
        var _this$draw2 = _this.draw(mouse.x, mouse.y, mouse.previous.x, mouse.previous.y),
            nx = _this$draw2.x,
            ny = _this$draw2.y;

        mouse.previous.set(nx, ny);
      }

      _this.endStroke(mouse.x, mouse.y);
    }; // attach listeners


    _this.canvas.addEventListener('mousemove', mouseMove);

    _this.canvas.addEventListener('mousedown', mouseDown);

    document.addEventListener('mouseup', mouseUp);

    _this.canvas.addEventListener('touchstart', mouseDown);

    _this.canvas.addEventListener('touchend', mouseUp);

    _this.canvas.addEventListener('touchmove', mouseMove); // helper for destroying Atrament (removing event listeners)


    _this.destroy = function () {
      _this.clear();

      _this.canvas.removeEventListener('mousemove', mouseMove);

      _this.canvas.removeEventListener('mousedown', mouseDown);

      document.removeEventListener('mouseup', mouseUp);

      _this.canvas.removeEventListener('touchstart', mouseDown);

      _this.canvas.removeEventListener('touchend', mouseUp);

      _this.canvas.removeEventListener('touchmove', mouseMove);
    }; // set internal canvas params


    _this.context = _this.canvas.getContext('2d');
    _this.context.globalCompositeOperation = 'source-over';
    _this.context.globalAlpha = 1;
    _this.context.strokeStyle = config.color || 'rgba(0,0,0,1)';
    _this.context.lineCap = 'round';
    _this.context.lineJoin = 'round';

    _this.context.translate(0.5, 0.5);

    _this._filling = false;
    _this._fillStack = []; // set drawing params

    _this.recordStrokes = false;
    _this.strokeMemory = [];
    _this.smoothing = Constants.initialSmoothingFactor;
    _this._thickness = Constants.initialThickness;
    _this._targetThickness = _this._thickness;
    _this._weight = _this._thickness;
    _this._maxWeight = _this._thickness + Constants.weightSpread;
    _this._mode = DrawingMode.DRAW;
    _this.adaptiveStroke = true; // update from config object

    ['weight', 'smoothing', 'adaptiveStroke', 'mode'].forEach(function (key) {
      return config[key] === undefined ? 0 : _this[key] = config[key];
    });
    return _this;
  }
  /**
   * Begins a stroke at a given position
   *
   * @param {number} x
   * @param {number} y
   */


  _createClass(Atrament, [{
    key: "beginStroke",
    value: function beginStroke(x, y) {
      this.context.beginPath();
      this.context.moveTo(x, y);

      if (this.recordStrokes) {
        this.strokeMemory.push(new Point(x, y));
      }

      this.dispatchEvent('strokestart', {
        x: x,
        y: y
      });
    }
    /**
     * Ends a stroke at a given position
     *
     * @param {number} x
     * @param {number} y
     */

  }, {
    key: "endStroke",
    value: function endStroke(x, y) {
      this.context.closePath();

      if (this.recordStrokes) {
        this.strokeMemory.push(new Point(x, y));
      }

      this.dispatchEvent('strokeend', {
        x: x,
        y: y
      });

      if (this.recordStrokes) {
        var stroke = {
          points: this.strokeMemory.slice(),
          mode: this.mode,
          weight: this.weight,
          smoothing: this.smoothing,
          color: this.color,
          adaptiveStroke: this.adaptiveStroke
        };
        this.dispatchEvent('strokerecorded', {
          stroke: stroke
        });
      }

      this.strokeMemory = [];
    }
    /**
     * Draws a smooth quadratic curve with adaptive stroke thickness
     * between two points
     *
     * @param {number} x current X coordinate
     * @param {number} y current Y coordinate
     * @param {number} prevX previous X coordinate
     * @param {number} prevY previous Y coordinate
     */

  }, {
    key: "draw",
    value: function draw(x, y, prevX, prevY) {
      if (this.recordStrokes) {
        this.strokeMemory.push(new Point(x, y));
      }

      var context = this.context; // calculate distance from previous point

      var rawDist = Pixels.lineDistance(x, y, prevX, prevY); // now, here we scale the initial smoothing factor by the raw distance
      // this means that when the mouse moves fast, there is more smoothing
      // and when we're drawing small detailed stuff, we have more control
      // also we hard clip at 1

      var smoothingFactor = Math.min(Constants.minSmoothingFactor, this.smoothing + (rawDist - 60) / 3000); // calculate processed coordinates

      var procX = x - (x - prevX) * smoothingFactor;
      var procY = y - (y - prevY) * smoothingFactor; // recalculate distance from previous point, this time relative to the smoothed coords

      var dist = Pixels.lineDistance(procX, procY, prevX, prevY);

      if (this.adaptiveStroke) {
        // calculate target thickness based on the new distance
        this._targetThickness = (dist - Constants.minLineThickness) / Constants.lineThicknessRange * (this._maxWeight - this._weight) + this._weight; // approach the target gradually

        if (this._thickness > this._targetThickness) {
          this._thickness -= Constants.thicknessIncrement;
        } else if (this._thickness < this._targetThickness) {
          this._thickness += Constants.thicknessIncrement;
        } // set line width


        context.lineWidth = this._thickness;
      } else {
        // line width is equal to default weight
        context.lineWidth = this._weight;
      } // draw using quad interpolation


      context.quadraticCurveTo(prevX, prevY, procX, procY);
      context.stroke();
      return {
        x: procX,
        y: procY
      };
    }
  }, {
    key: "isDirty",
    value: function isDirty() {
      return !!this._dirty;
    }
  }, {
    key: "fireDirty",
    value: function fireDirty() {
      this.dispatchEvent('dirty');
    }
  }, {
    key: "clear",
    value: function clear() {
      if (!this.isDirty) {
        return;
      }

      this._dirty = false;
      this.dispatchEvent('clean'); // make sure we're in the right compositing mode, and erase everything

      if (this.mode === DrawingMode.ERASE) {
        this.mode = DrawingMode.DRAW;
        this.context.clearRect(-10, -10, this.canvas.width + 20, this.canvas.height + 20);
        this.mode = DrawingMode.ERASE;
      } else {
        this.context.clearRect(-10, -10, this.canvas.width + 20, this.canvas.height + 20);
      }
    }
  }, {
    key: "toImage",
    value: function toImage() {
      return this.canvas.toDataURL();
    }
  }, {
    key: "fill",
    value: function fill() {
      var _this2 = this;

      var mouse = this.mouse;
      var context = this.context; // converting to Array because Safari 9

      var startColor = Array.from(context.getImageData(mouse.x, mouse.y, 1, 1).data);

      if (!this._filling) {
        var x = mouse.x,
            y = mouse.y;
        this.dispatchEvent('fillstart', {
          x: x,
          y: y
        });
        this._filling = true;
        setTimeout(function () {
          _this2._floodFill(mouse.x, mouse.y, startColor);
        }, Constants.floodFillInterval);
      } else {
        this._fillStack.push([mouse.x, mouse.y, startColor]);
      }
    }
  }, {
    key: "_floodFill",
    value: function _floodFill(_startX, _startY, startColor) {
      var context = this.context;
      var startX = Math.floor(_startX);
      var startY = Math.floor(_startY);
      var canvasWidth = context.canvas.width;
      var canvasHeight = context.canvas.height;
      var pixelStack = [[startX, startY]]; // hex needs to be trasformed to rgb since colorLayer accepts RGB

      var fillColor = Pixels.hexToRgb(this.color); // Need to save current context with colors, we will update it

      var colorLayer = context.getImageData(0, 0, context.canvas.width, context.canvas.height);
      var alpha = Math.min(context.globalAlpha * 10 * 255, 255);
      var colorPixel = Pixels.colorPixel.apply(Pixels, [colorLayer.data].concat(_toConsumableArray(fillColor), [startColor, alpha]));
      var matchColor = Pixels.matchColor.apply(Pixels, [colorLayer.data].concat(_toConsumableArray(startColor)));
      var matchFillColor = Pixels.matchColor.apply(Pixels, [colorLayer.data].concat([].concat(_toConsumableArray(fillColor), [255]))); // check if we're trying to fill with the same colour, if so, stop

      if (matchFillColor((startY * context.canvas.width + startX) * 4)) {
        this._filling = false;
        this.dispatchEvent('fillend', {});
        return;
      }

      while (pixelStack.length) {
        var newPos = pixelStack.pop();
        var x = newPos[0];
        var y = newPos[1];
        var pixelPos = (y * canvasWidth + x) * 4;

        while (y-- >= 0 && matchColor(pixelPos)) {
          pixelPos -= canvasWidth * 4;
        }

        pixelPos += canvasWidth * 4;
        ++y;
        var reachLeft = false;
        var reachRight = false;

        while (y++ < canvasHeight - 1 && matchColor(pixelPos)) {
          colorPixel(pixelPos);

          if (x > 0) {
            if (matchColor(pixelPos - 4)) {
              if (!reachLeft) {
                pixelStack.push([x - 1, y]);
                reachLeft = true;
              }
            } else if (reachLeft) {
              reachLeft = false;
            }
          }

          if (x < canvasWidth - 1) {
            if (matchColor(pixelPos + 4)) {
              if (!reachRight) {
                pixelStack.push([x + 1, y]);
                reachRight = true;
              }
            } else if (reachRight) {
              reachRight = false;
            }
          }

          pixelPos += canvasWidth * 4;
        }
      } // Update context with filled bucket!


      context.putImageData(colorLayer, 0, 0);

      if (this._fillStack.length) {
        this._floodFill.apply(this, _toConsumableArray(this._fillStack.shift()));
      } else {
        this._filling = false;
        this.dispatchEvent('fillend', {});
      }
    }
  }, {
    key: "color",
    get: function get() {
      return this.context.strokeStyle;
    },
    set: function set(c) {
      if (typeof c !== 'string') throw new Error('wrong argument type');
      this.context.strokeStyle = c;
    }
  }, {
    key: "weight",
    get: function get() {
      return this._weight;
    },
    set: function set(w) {
      if (typeof w !== 'number') throw new Error('wrong argument type');
      this._weight = w;
      this._thickness = w;
      this._targetThickness = w;
      this._maxWeight = w + Constants.weightSpread;
    }
  }, {
    key: "mode",
    get: function get() {
      return this._mode;
    },
    set: function set(m) {
      if (typeof m !== 'string') throw new Error('wrong argument type');

      switch (m) {
        case DrawingMode.ERASE:
          this._mode = DrawingMode.ERASE;
          this.context.globalCompositeOperation = 'destination-out';
          break;

        case DrawingMode.FILL:
          this._mode = DrawingMode.FILL;
          this.context.globalCompositeOperation = 'source-over';
          break;

        default:
          this._mode = DrawingMode.DRAW;
          this.context.globalCompositeOperation = 'source-over';
          break;
      }
    }
  }]);

  return Atrament;
}(AtramentEventTarget);